import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { reactionsTypeCountBackend } from './reactions-type-count.backend';
import { reactionsTypeCountReducer } from './reactions-type-count.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('reactionsTypeCount', reactionsTypeCountReducer),
    BackendModule.forFeature('reactionsTypeCount', reactionsTypeCountBackend),
  ],
})
export class DatastoreReactionsTypeCountModule {}
